import { connect } from 'react-redux';
import Measurement from '../../components/handoff/Measurement';
import { getPixelRatio, getUnit } from '../../selectors/handoff';
import { getPlatform } from '../../selectors/project';
function mapStateToProps(state, _a) {
    var unit = _a.unit;
    return {
        unit: unit || getUnit(state),
        pixelRatio: getPixelRatio(state),
        platform: getPlatform(state),
    };
}
export default connect(mapStateToProps)(Measurement);
